// extracted by mini-css-extract-plugin
module.exports = {"flex":"style__flex__05SwC","modalFooter":"style__modalFooter__dqCyg","button":"style__button__4QSWO","grey":"style__grey__sWyyB"};